import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { routes } from "../../../routes.ts";
import { useIngredient } from "../IngredientContext.tsx";

export const CancelEditButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { ingredient } = useIngredient();

  if (!ingredient.hasPublishedVersion) return null;

  return (
    <Button
      icon={<CloseOutlined />}
      onClick={() => void navigate({ pathname: routes.ingredientDetail.to(ingredient.id), hash: location.hash })}
    >
      {t("common.cancel")}
    </Button>
  );
};
